import { useEffect, useState } from "react";
import { Globe, Monitor } from "lucide-react";
import { C, Icon, Label, Packet, Pop, Svg, useTick } from "./shared";

const LANES = [188, 200, 212];
const THREATS = ["185.220.101.4 · ET SCAN", "45.155.205.9 · BRUTE FORCE", "103.75.190.2 · MALWARE C2", "91.240.118.7 · SQLi PROBE", "194.26.29.1 · PORT SWEEP"];
const PLAIN = {
  "ET SCAN": "someone scanning your network for weak spots",
  "BRUTE FORCE": "a bot repeatedly guessing passwords",
  "MALWARE C2": "infected software trying to phone home",
  "SQLi PROBE": "an attempt to break in through a web form",
  "PORT SWEEP": "a bot checking for unlocked doors",
};

const Bars = () => (
  <g>
    {Array.from({ length: 7 }).map((_, i) => (
      <rect key={i} x={146 + i * 4.5} y="186" width="3" height="18" fill={C.cyan} className="eq" style={{ animationDelay: `${i * 0.13}s`, transformOrigin: `${147 + i * 4.5}px 204px` }} />
    ))}
  </g>
);

const UDM = () => (
  <g>
    <rect x="130" y="168" width="340" height="64" rx="4" fill="url(#silver)" stroke="#8A94A3" />
    <rect x="140" y="178" width="46" height="44" rx="2" fill="#0B1220" />
    <Bars />
    <circle cx="200" cy="200" r="3" fill={C.blue} className="blink" />
    {Array.from({ length: 8 }).map((_, i) => (
      <g key={i}>
        <rect x={300 + (i % 4) * 22} y={i < 4 ? 180 : 204} width="18" height="16" rx="1.5" fill="#1F2937" />
        <rect x={302 + (i % 4) * 22} y={i < 4 ? 178 : 202} width="3" height="2" fill={C.green} className="blink" style={{ animationDelay: `${i * 0.21}s` }} />
      </g>
    ))}
    {[0, 1].map((i) => <rect key={i} x={400 + i * 30} y="190" width="24" height="18" rx="1.5" fill="#374151" />)}
  </g>
);

export const FirewallAnim = ({ say }) => {
  const [n, setN] = useState(1284);
  const [log, setLog] = useState(THREATS.slice(0, 3));
  useTick(() => {
    setN((v) => v + 1 + Math.floor(Math.random() * 3));
    setLog((l) => [THREATS[Math.floor(Math.random() * THREATS.length)], ...l].slice(0, 3));
  }, 1100);
  useEffect(() => {
    say(`Just blocked ${PLAIN[log[0].split(" · ")[1]]} — your normal traffic keeps flowing.`);
  }, [log, say]);

  return (
    <Svg>
      <Icon as={Globe} x={40} y={200} s={24} color={C.dim} />
      <Label x={40} y={232}>INTERNET</Label>
      <Icon as={Monitor} x={560} y={200} s={24} color={C.text} />
      <Label x={560} y={232}>LAN</Label>
      {LANES.map((y, i) => (
        <g key={y}>
          <Packet d={`M60,${y} L540,${y}`} dur={2.6} begin={i * 0.8} color={C.green} />
          <Packet d={`M60,${y} L124,${y}`} dur={1.4} begin={i * 0.5 + 0.2} color={C.red} r={3.2} />
        </g>
      ))}
      <rect x="118" y="140" width="12" height="120" rx="6" fill="rgba(0,240,255,0.08)" stroke={C.cyan} strokeOpacity="0.8" strokeDasharray="3 4" />
      <circle cx="124" cy="200" r="10" fill="none" stroke={C.red} className="burst" />
      <Label x={124} y={132} color={C.cyan} size={8}>IPS ENGINE</Label>
      <Pop delay={0.2}><UDM /></Pop>
      <Label x={300} y={156} color={C.text} size={11}>DREAM MACHINE PRO</Label>
      <Label x={300} y={252} size={8}>NGFW · IDS/IPS · VPN · GEO-IP · ZONES</Label>
      <rect x="150" y="280" width="300" height="92" rx="4" fill="#0B0F17" stroke="#1F2937" />
      <Label x={165} y={300} anchor="start" size={8}>THREATS BLOCKED TODAY</Label>
      <text x="435" y="302" textAnchor="end" fill={C.red} fontFamily="Outfit" fontWeight="800" fontSize="18" data-testid="firewall-counter">{n.toLocaleString()}</text>
      {log.map((l, i) => (
        <Label key={`${l}-${i}-${n}`} x={165} y={322 + i * 16} anchor="start" size={8} color={i === 0 ? C.red : C.dim}>✕ BLOCKED {l}</Label>
      ))}
    </Svg>
  );
};
